import type { Components, Theme } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';

// ----------------------------------------------------------------------

const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor:
        theme.palette.mode === 'dark'
          ? theme.palette.grey[700]
          : theme.palette.grey[800],
    }),
    arrow: ({ theme }) => ({
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.grey[700]
          : theme.palette.grey[800],
    }),
    popper: {
      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
        {
          marginTop: 12,
        },
      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
        {
          marginBottom: 12,
        },
      [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
        {
          marginLeft: 12,
        },
      [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
        {
          marginRight: 12,
        },
    },
  },
};

// ----------------------------------------------------------------------

export const tooltip = { MuiTooltip };
